import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import MenuDrawer from "components/drawer/MenuDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ActiveMenu from "components/table/ActiveMenu";
import EditDeleteButton from "components/table/EditDeleteButton";
import Tooltip from "components/tooltip/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useContext } from "react";
import ViewModal from "components/modal/ViewMenudetails";
import { SidebarContext } from "context/SidebarContext";
import { FiEye } from "react-icons/fi";

import { notifyError, notifySuccess } from "utils/toast";
import MenuServices from "services/MenuServices";
// internal imports

const MenuTable = ({
  menu,
  perpage,
  currentPage,
  tab,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleMenuDetails, handleModalOpen, handleUpdate } =
    useToggleDrawer();

  const { setIsUpdate } = useContext(SidebarContext);

  const handleMenu = async (id, currentStatus, titleActive) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    try {
      const response = await MenuServices.updateActiveStatus(id, {
        status: newStatus,
      });
      if (response.status) {
        notifySuccess(`Status Updated Successfully`);
        setIsUpdate(true);
      } else {
        notifyError("Failed to update status");
      }
    } catch (error) {
      notifyError("An error occurred while updating status");
      console.error(error);
    }
  };

  return (
    <>
      <ViewModal id={serviceId} title={title} data={menu} />

      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <MenuDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {menu?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell>
              <span className="font-semibold uppercase text-xs text-center">
                {(currentPage - 1) * perpage + index + 1}
              </span>
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.parent_name}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.sub_parent_name}
            </TableCell>
            <TableCell className="text-sm text-center">{data.name}</TableCell>
            <TableCell className="text-sm text-center">
              {data.position}
            </TableCell>
            <TableCell className="text-sm text-center">{data.path}</TableCell>
            <TableCell className="text-center">
              <ActiveMenu
                id={data.id_menu}
                active={data.is_active}
                title_active={"Active"}
                handleMenu={handleMenu}
              />
            </TableCell>

            <TableCell>
              <div className="flex justify-center">
                <button
                  onClick={() => handleMenuDetails(data.id, "Menu Details")}
                  className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                >
                  <Tooltip
                    id={data.id}
                    Icon={FiEye}
                    title="ViewOrder"
                    bgColor="#34D399"
                  />
                </button>
                <EditDeleteButton
                  title={data.name}
                  id={data.id_menu}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideDelete={hideDelete}
                  hideEdit={hideEdit}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default MenuTable;
